import { Box, Typography } from "@material-ui/core";
import { Fragment, useState } from "react";
import { useI18nFieldState } from "../../hooks";
import { I18NLanguagePicker } from "../i18n_language_picker";
import { MarkdownEditor, MarkdownEditorProps } from "../markdown_editor";

export interface I18NMarkdownEditorProps<T>
  extends Omit<MarkdownEditorProps, "value" | "onChange" | "valueChange"> {
  i18nFieldName: string;
  value: T;
  onChange: (newValue: T) => void;
  label?: string;
}
export function I18NMarkdownEditor<T>(props: I18NMarkdownEditorProps<T>) {
  const { label, value, onChange, i18nFieldName, ...markdownEditorProps } =
    props;

  const [selectedLanguage, setSelectedLanguage] = useState<string>("it");
  const { displayedValue, triggerSetValue } = useI18nFieldState(
    i18nFieldName,
    selectedLanguage,
    value,
    onChange
  );

  return (
    <Fragment>
      <MarkdownEditor
        header={
          <Box
            width="100%"
            style={{
              display: "flex",
              gap: "1rem",
              placeItems: "center",
            }}
          >
            <Typography variant="caption">Lingua:</Typography>
            <I18NLanguagePicker
              value={selectedLanguage}
              onChange={(value) => setSelectedLanguage(value)}
            />
            {label && <label>{label}</label>}
          </Box>
        }
        {...markdownEditorProps}
        value={displayedValue}
        valueChange={triggerSetValue}
      />
    </Fragment>
  );
}
